export default __webpack_public_path__ + "static/media/16.b99df675.jpeg";